// extracted by mini-css-extract-plugin
export default {"title":"each-kiosk-item-prices_title__UiTFE"};